import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  navigationState: [],
  filteringFormsState: {
    orderFilteringForm: {},
    returnsParcelFilteringForm: {},
    toSendParcelFilteringForm: {},
    cargoFilteringForm: {},
    parcelsFilteringForm: {},
    clientsFilteringForm: {},
    unknownGoodFilteringForm: {},
    cargoScanningFilteringForm: {},
    parcelsRegisterOfConsignmentsFilteringForm: {},
    weighingFilterForm: {},
    accountListFilteringForm: {},
    exchangeFilteringForm: {},
    transactionsFilteringForm: {},
    complectationParcelSearch: {},
    weightingParcelSearch: {},
    payParcelSearch: {},
    sendParcelSearch: {},
  },
}

const slice = createSlice({
  name: 'navigationState',
  initialState,
  reducers: {
    setDynamicNavPaths(state, action) {
      const navigationState = action.payload
      state.navigationState = navigationState
    },
    removeDynamicPath(state, action) {
      const href = action.payload
      state.navigationState.splice(
        state.navigationState.findIndex((el) => el.href === href),
        1
      )
    },
    setFilteringForms(state, action) {
      const { orderFilteringForm } = action.payload
      const { returnsParcelFilteringForm } = action.payload
      const { toSendParcelFilteringForm } = action.payload
      const { cargoFilteringForm } = action.payload
      const { parcelsFilteringForm } = action.payload
      const { clientsFilteringForm } = action.payload
      const { unknownGoodFilteringForm } = action.payload
      const { cargoScanningFilteringForm } = action.payload
      const { cargoScanningOnDeviceFilteringForm } = action.payload
      const { exchangeFilteringForm } = action.payload
      const { transactionsFilteringForm } = action.payload
      const { accountListFilteringForm } = action.payload
      const { parcelsRegisterOfConsignmentsFilteringForm } = action.payload
      const { weighingFilterForm } = action.payload
      const { complectationParcelSearch } = action.payload
      const { weightingParcelSearch } = action.payload
      const { payParcelSearch } = action.payload
      const { sendParcelSearch } = action.payload
      if (orderFilteringForm) {
        state.filteringFormsState.orderFilteringForm = orderFilteringForm
      }
      if (parcelsRegisterOfConsignmentsFilteringForm) {
        state.filteringFormsState.parcelsRegisterOfConsignmentsFilteringForm = parcelsRegisterOfConsignmentsFilteringForm
      }
      if (weighingFilterForm) {
        state.filteringFormsState.weighingFilterForm = weighingFilterForm
      }
      if (complectationParcelSearch) {
        state.filteringFormsState.complectationParcelSearch = complectationParcelSearch
      }
      if (weightingParcelSearch) {
        state.filteringFormsState.weightingParcelSearch = weightingParcelSearch
      }
      if (payParcelSearch) {
        state.filteringFormsState.payParcelSearch = payParcelSearch
      }
      if (sendParcelSearch) {
        state.filteringFormsState.sendParcelSearch = sendParcelSearch
      }
      state.filteringFormsState.returnsParcelFilteringForm =
        returnsParcelFilteringForm || {}
      state.filteringFormsState.toSendParcelFilteringForm =
        toSendParcelFilteringForm || {}
      state.filteringFormsState.cargoFilteringForm = cargoFilteringForm || {}
      state.filteringFormsState.parcelsFilteringForm =
        parcelsFilteringForm || {}
      state.filteringFormsState.clientsFilteringForm =
        clientsFilteringForm || {}
      state.filteringFormsState.unknownGoodFilteringForm =
        unknownGoodFilteringForm || {}
      state.filteringFormsState.cargoScanningFilteringForm =
        cargoScanningFilteringForm || {}
      state.filteringFormsState.cargoScanningOnDeviceFilteringForm =
        cargoScanningOnDeviceFilteringForm || {}
      state.filteringFormsState.exchangeFilteringForm =
        exchangeFilteringForm || {}
      state.filteringFormsState.transactionsFilteringForm =
        transactionsFilteringForm || {}
      state.filteringFormsState.accountListFilteringForm =
        accountListFilteringForm || {}
    },
    cleanFilteringForm(state) {
      state.filteringFormsState = {}
    },
  },
})

export const reducer = slice.reducer

export const setDynamicNavState = (data) => async (dispatch) => {
  dispatch(slice.actions.setDynamicNavPaths(data))
}
export const removeDynamicNav = (data) => async (dispatch) => {
  dispatch(slice.actions.removeDynamicPath(data))
}
export const setFilteringFormsData = (data) => async (dispatch) => {
  dispatch(slice.actions.setFilteringForms(data))
}

export const cleanFilteringFormData = () => async (dispatch) => {
  dispatch(slice.actions.cleanFilteringForm())
}
export default slice
